var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-heading',{attrs:{"mainTitle":_vm.title,"subTitle":_vm.subtitle}}),_vm._v(" "),_c('div',{staticClass:"minibasket__link-area"},_vm._l((_vm.requestLinks),function(item){return _c('div',{key:item.id,staticClass:"minibasket__link-box"},[_c('app-linker',{attrs:{"htmlBefore":"<i class='fas fa-chevron-right link-box__icon'></i> ","link":item.acf,"classData":"link-box__link"}})],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dae22a60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/shared/RelatedLinkSection.vue
// module id = 181
// module chunks = 34